module.exports = __webpack_public_path__ + "img/logo0.007f7eb1.png";